import { initSwiperContainer } from "@modules/util/swiper"
import "./events-slider.css"
import type { SwiperContainer } from "swiper/element"
// @ts-expect-error typescript cannot find a type for this file.
import swiperCssNavigation from "swiper/element/css/navigation?raw"
import { Navigation } from "swiper/modules"

const el = document.getElementById("events-slider") as SwiperContainer

initSwiperContainer(el, {
    slidesOffsetAfter: 225,
    slidesPerView: "auto",
    spaceBetween: 15,
    initialSlide: 0,
    pagination: false,
    watchOverflow: false,
    navigation: {
        enabled: true,
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    modules: [Navigation],
    injectStyles: [swiperCssNavigation],
    centeredSlides: true,
    slidesOffsetBefore: -225,
    breakpoints: {
        992: {
            slidesOffsetBefore: -335,
        },
        1200: {
            slidesOffsetBefore: -440,
        },
    },
})
